import type { JSX } from 'react';

import { Loader2 } from 'lucide-react';

import {
  UsersAlertDialog as AlertDialog,
  UsersAlertDialogAction as AlertDialogAction,
  UsersAlertDialogCancel as AlertDialogCancel,
  UsersAlertDialogContent as AlertDialogContent,
  UsersAlertDialogDescription as AlertDialogDescription,
  UsersAlertDialogFooter as AlertDialogFooter,
  UsersAlertDialogHeader as AlertDialogHeader,
  UsersAlertDialogTitle as AlertDialogTitle,
} from './ui/UsersAlertDialog';

export type UserActiveConfirmAction = 'deactivate' | 'reactivate';

interface UserActiveConfirmDialogProps {
  open: boolean;
  action: UserActiveConfirmAction | null;
  userLabel: string;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const UserActiveConfirmDialog = ({
  open,
  action,
  userLabel,
  isLoading,
  onClose,
  onConfirm,
}: UserActiveConfirmDialogProps): JSX.Element | null => {
  if (!action) return null;

  const isDeactivate = action === 'deactivate';

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{isDeactivate ? 'Desactivar usuario' : 'Reactivar usuario'}</AlertDialogTitle>
          <AlertDialogDescription>
            {isDeactivate
              ? `¿Estás seguro de que deseas desactivar a ${userLabel}? El usuario perderá acceso al sistema.`
              : `¿Estás seguro de que deseas reactivar a ${userLabel}? El usuario recuperará acceso al sistema.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading} onClick={onClose}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            variant={isDeactivate ? 'destructive' : 'default'}
            disabled={isLoading}
            className="gap-2"
            onClick={onConfirm}
          >
            {isLoading ? <Loader2 className="size-4 animate-spin" aria-hidden /> : null}
            Confirmar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default UserActiveConfirmDialog;
